import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconEyeOff = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.576 3.141l.567-.566a.599.599 0 01.848 0l3.687 3.717L9.15 7.765l7.391 7.39 1.426 1.425 3.56 3.531a.6.6 0 010 .85l-.566.565a.598.598 0 01-.848 0l-3.808-3.808C14.844 18.563 13.389 19 12 19c-2.254 0-4.682-1.15-7.021-3.328-1.75-1.63-2.829-3.24-2.874-3.308a.68.68 0 010-.728c.045-.068 1.124-1.678 2.874-3.308.345-.321.693-.62 1.04-.896L2.577 3.989a.6.6 0 010-.848zm4.867 5.715c-.365.28-.732.592-1.101.936A19.177 19.177 0 004.46 11.82l-.143.18.143.18a19.172 19.172 0 001.88 2.028C8.339 16.067 10.308 17 12 17c.88 0 1.834-.253 2.83-.757l-1.535-1.536A3 3 0 019 12c0-.462.104-.902.291-1.296L7.443 8.856zm3.827-1.8L9.62 5.404A7.537 7.537 0 0112 5c2.254 0 4.682 1.15 7.021 3.328 1.75 1.63 2.829 3.24 2.873 3.308a.68.68 0 010 .728c-.04.062-.943 1.41-2.431 2.884l-1.414-1.415a19.54 19.54 0 001.488-1.653l.143-.18-.143-.18a19.352 19.352 0 00-1.879-2.028C15.66 7.933 13.691 7 12 7c-.238 0-.482.019-.73.055z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconEyeOff.displayName = "IconEyeOff";
